
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, Star, Clock, Award, Home } from 'lucide-react';

interface WhyChooseUsProps {
  locationName: string;
  description: string;
}

const WhyChooseUs: React.FC<WhyChooseUsProps> = ({ locationName, description }) => {
  const features = [
    {
      icon: Star,
      color: "text-yellow-500",
      title: "Local Expertise:",
      description: "Deep understanding of Nash and Edgecombe County weather patterns and building codes"
    },
    {
      icon: Clock,
      color: "text-red-500",
      title: "Emergency Response:",
      description: "24/7 storm damage response with average 3.8-hour response time"
    },
    {
      icon: Shield,
      color: "text-blue-500",
      title: "Insurance Specialists:",
      description: "Dedicated claims department at claims@CarolinaTrophy"
    },
    {
      icon: Award,
      color: "text-green-500",
      title: "FORTIFIED Certified:",
      description: "Advanced storm-resistant construction following IBHS standards"
    },
    {
      icon: Home,
      color: "text-purple-500",
      title: "Community-Focused:",
      description: "Committed to the Twin Counties with local ownership and investment"
    }
  ];

  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6 flex items-center">
        <Shield className="h-8 w-8 text-primary mr-3" />
        Your Trusted {locationName} Roofing Experts
      </h2>
      <p className="text-lg mb-6">
        {description}
      </p>

      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="text-2xl">Why {locationName} Homeowners Choose Carolina Trophy Roofs:</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-2 gap-4">
            <ul className="space-y-3">
              {features.slice(0, 3).map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <li key={index} className="flex items-start">
                    <IconComponent className={`h-5 w-5 ${feature.color} mr-2 mt-0.5 flex-shrink-0`} />
                    <span><strong>{feature.title}</strong> {feature.description}</span>
                  </li>
                );
              })}
            </ul>
            <ul className="space-y-3">
              {features.slice(3).map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <li key={index} className="flex items-start">
                    <IconComponent className={`h-5 w-5 ${feature.color} mr-2 mt-0.5 flex-shrink-0`} />
                    <span><strong>{feature.title}</strong> {feature.description}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default WhyChooseUs;
